export const removeHtmlTags = (str: string) => {
  return new DOMParser().parseFromString(str, 'text/html').body.textContent;
};
